import "./App.css";
import React from "react";
import Home from "./sections/Home";
import About from "./sections/About";
import Skills from "./sections/Skills";
import Projects from "./sections/Projects";
import Contact from "./sections/Contact";
import Navbar from "./components/Navbar";
import { Element } from "react-scroll";

function App() {
  return (
    <div className="App">
      <Navbar />
      <Element id="box-0">
        <Home />
      </Element>
      <Element id="box-1">
        <About />
      </Element>
      <Element id="box-2">
        <Skills />
      </Element>
      <Element id="box-3">
        <Projects />
      </Element>
      <Element id="box-4">
        <Contact />
      </Element>
    </div>
  );
}

export default App;
